<template>
    <div>
        <!-- مودال تغییر وضعیت -->
        <appointment-status-modal 
            ref="statusForm" 
            :is-loading="isLoadingGrid" 
            @on-save="handleStatusUpdate" 
        />

        <bita-breadcrumb :items="breadCrumbs" />

        <div class="wrapper wrapper-content animated fadeInRight">
            <bita-ibox :is-loading="isLoadingGrid">
                <div slot="body">
                    
                    <!-- بخش فیلترها -->
                    <div class="row mb-4 bg-light p-3 rounded border">
                        <div class="col-12 mb-2"><strong>فیلتر نوبت‌ها:</strong></div>
                        <bita-select
                            name="filter_doctor"
                            label="انتخاب پزشک"
                            :validation-container-class="col4"
                            :data-source="doctors"
                            data-text-field="name"
                            data-value-field="id"
                            v-model="filters.doctor_id"
                        />
                        <bita-select
                            name="filter_status"
                            label="وضعیت"
                            :validation-container-class="col4"
                            :data-source="statusOptions"
                            data-text-field="title"
                            data-value-field="value"
                            v-model="filters.status"
                        />
                        
                        <div class="col-lg-4 d-flex align-items-end mb-3">
                            <bita-bootbutton type="info" title="جستجو" icon="fas fa-search" @click.native="loadData" />
                            <bita-bootbutton type="default" title="پاک کردن" class="mr-2" @click.native="clearFilters" />
                        </div>
                    </div>

                    <hr />

                    <bita-grid 
                        ref="grid" 
                        :columns="gridColumns" 
                        :read-data="readData" 
                        :page-size="pageSize"
                        :current-page="currentPage" 
                        :has-row-number="true" 
                        :grid-server-side="true"
                        :schema-total="'total'" 
                        :schema-data="'data'" 
                        :server-paging="true"
                        :batch="true" 
                    />
                </div>
            </bita-ibox>
        </div>
    </div>
</template>

<script>
import { filter } from 'lodash';
import appointmentsApi from '../../../api/clinic/appointmentsApi';
import AppointmentStatusModal from './components/AppointmentStatusModal';
import doctorsApi from '../../../api/clinic/doctorsApi';


export default {
    components: { AppointmentStatusModal },
    data() {
        return {
            col4: "col-lg-4",
            pageSize: 15,
            currentPage: 1,
            isLoadingGrid: false,
            doctors:[],
            breadCrumbs: [
                { title: "صفحه اصلی", link: "/" },
                { title: "مدیریت نوبت‌های رزرو شده", link: "/clinic/appointments", active: true },
            ],
            filters: {
                status: '',
                doctor_id:''
            },
            statusOptions: [
                { title: "همه", value: null },
                { title: "در انتظار", value: 0 },
                { title: "تایید شده", value: 1 },
                { title: "لغو شده", value: 2 },
            ]
        };
    },

    computed: {
        gridColumns() {
            return [
                { 
                    field: "code", 
                    title: "کد پیگیری", 
                    template: ({ code }) => `<strong>${code}</strong>` 
                },
                { 
                    field: "user", 
                    title: "بیمار", 
                    template: ({ user }) => user ? (user.name || user.mobile) : " - " 
                },
                { 
                    field: "visit", 
                    title: "پزشک", 
                    template: ({ visit }) => visit?.doctor?.name || " - " 
                },
                { 
                    field: "visit_date", 
                    title: "تاریخ و ساعت", 
                    template: ({ visit }) => {
                        if(!visit) return " - ";
                        const time = visit.start_time ? visit.start_time.substring(0, 5) : '';
                        return `<span class="ltr" dir="ltr">${this.$getJalaliDate(visit.date)} ${time}</span>`;
                    }
                },
                { 
                    field: "status", 
                    title: "وضعیت", 
                    template: ({ status }) => this.getStatusBadge(status) 
                },
                { 
                    field: "payment", 
                    title: "وضعیت پرداخت", 
                    template: ({ payment_method, is_success_payment }) => {
                        let method = payment_method == 2 ? "آنلاین" : (payment_method == 1 ? "پیش پرداخت" : "در محل");
                        let success = is_success_payment ? '<i class="fas fa-check text-success"></i>' : '<i class="fas fa-times text-danger"></i>';
                        return `${method} ${success}`;
                    }
                },
                { title: "عملیات", command: this.gridCommands() },
            ];
        },
    },
    mounted() {
        this.loadDoctors();
    },

    methods: {
        loadDoctors() {
            // دریافت لیست پزشکان بدون صفحه بندی (یا تعداد بالا) برای دراپ‌داون‌ها
            doctorsApi.get({ page_size: 1000 }).then(({ data }) => {
                this.doctors = data.data.data || data.data || data;
            });
        },
        getStatusBadge(status) {
            if (status === 0) return '<span class="badge badge-warning">در انتظار</span>';
            if (status === 1) return '<span class="badge badge-success">تایید شده</span>';
            if (status === 2) return '<span class="badge badge-danger">لغو شده</span>';
            return '<span class="badge badge-secondary">نامشخص</span>';
        },

        clearFilters() {
            this.filters.status = '';
            this.filters.doctor_id='';
            this.loadData();
        },

        loadData() {
            this.$refs.grid.loadDataSource();
        },

        readData(e) {
            this.$resetGrid();
            this.pageSize = e.data.pageSize;
            this.currentPage = e.data.page;
            this.isLoadingGrid = true;

            const queryParams = {
                page_size: this.pageSize,
                page: this.currentPage,
                ...this.filters
            };

            appointmentsApi.get(queryParams)
                .then(({ data }) => {
                    e.success(data);
                })
                .catch(() => {
                    e.success([]);
                })
                .finally(() => {
                    this.isLoadingGrid = false;
                });
        },

        editStatus(e) {
            const data = this.$refs.grid.getSelectedGridRow(e);
            this.$refs.statusForm.init(data);
            this.$toggleModal("#appointment-status-form");
        },

        handleStatusUpdate(formData) {
            this.isLoadingGrid = true;
            appointmentsApi.update(formData.id, { status: formData.status })
                .then(() => {
                    this.$izitoast("success", "عملیات موفق", "وضعیت نوبت با موفقیت تغییر کرد.");
                    this.$toggleModal("#appointment-status-form");
                    this.loadData();
                })
                .catch((err) => {
                    if(err.response && err.response.data && err.response.data.message) {
                        this.$izitoast("error", "خطا", err.response.data.message);
                    }
                })
                .finally(() => {
                    this.isLoadingGrid = false;
                });
        },

        delete(e) {
            const data = this.$refs.grid.getSelectedGridRow(e);

            this.$alert("question", `آیا از حذف کامل این نوبت (کد: ${data.code}) اطمینان دارید؟`, "این عملیات غیر قابل بازگشت است و بازه زمانی آزاد خواهد شد.", {
                confirmButtonText: "بله، حذف شود",
            }).then((result) => {
                if (result.value) {
                    this.isLoadingGrid = true;
                    appointmentsApi.delete(data.id)
                        .then(() => {
                            this.$izitoast("success", "عملیات موفق", "نوبت حذف شد.");
                            this.loadData();
                        })
                        .finally(() => {
                            this.isLoadingGrid = false;
                        });
                }
            });
        },

        gridCommands() {
            return [
                { text: "edit", template: this.gridButtons.edit, click: this.editStatus },
                { text: "delete", template: this.gridButtons.delete, click: this.delete },
            ];
        },
    },
};
</script>
